import { combineReducers } from "redux";
import { ACTION_TYPES, INITIAL_GLOBAL_STATE } from "./constants";

function activePlanet(state = INITIAL_GLOBAL_STATE.activePlanet, action) {
  switch (action.type) {
    case ACTION_TYPES.SET_ACTIVE_PLANET:
      return action.activePlanet;

    default:
      return state;
  }
}

const CoM = combineReducers({
  activePlanet,
});

export default CoM;
